import React, { useEffect } from 'react';
import { ChangePasswordFlow } from '../user-page/pages/profile/components/password-change/change-password-flow';
import globalUserProfile from '../../stores/global-user-profile';
import { observer } from 'mobx-react-lite';
import { useNavigate } from 'react-router-dom';
import './change-password-required-page.css';

export const ChangePasswordRequiredPage: React.FC = observer(() => {
  const navigate = useNavigate();
  const [userEmail, setUserEmail] = React.useState<string>('');
  const [userPhoneNumber, setUserPhoneNumber] = React.useState<string>('');
  const [isLoading, setIsLoading] = React.useState(true);

  useEffect(() => {
    // Try to get user profile to extract email
    const fetchUserEmail = async () => {
      try {
        // Check if we already have the email from userProfile
        if (globalUserProfile.userProfile?.userWithRole?.email) {
          setUserEmail(globalUserProfile.userProfile.userWithRole.email);
          setUserPhoneNumber(
            globalUserProfile.userProfile.userWithRole.phoneNumber,
          );
          setIsLoading(false);
          return;
        }

        // Try to fetch profile (this may fail with PASSWORD_CHANGE_REQUIRED)
        if (!globalUserProfile.userType) {
          await globalUserProfile.getUserProfile();
        }

        // If successful, get the email
        if (globalUserProfile.userProfile?.userWithRole?.email) {
          setUserEmail(globalUserProfile.userProfile.userWithRole.email);
          setUserPhoneNumber(
            globalUserProfile.userProfile.userWithRole.phoneNumber,
          );
        }
      } catch (error) {
        // If API call fails with PASSWORD_CHANGE_REQUIRED, we still need to show the form
        // Use a generic message since we can't get the email
        console.error('Error fetching user profile:', error);
        // Set a placeholder - the OTP will still be sent to the correct email on the server side
        setUserEmail('כתובת הדוא"ל שלך');
      } finally {
        setIsLoading(false);
      }
    };

    fetchUserEmail();
  }, []);

  const handlePasswordChangeSuccess = () => {
    // Get the redirect path from sessionStorage
    const redirectPath = sessionStorage.getItem('redirectAfterPasswordChange');

    // Clear the stored redirect path
    sessionStorage.removeItem('redirectAfterPasswordChange');

    // Redirect to the stored path or home page
    setTimeout(() => {
      navigate(redirectPath || '/');
    }, 1500); // Small delay to show success message
  };

  return (
    <div className="change-password-required-container">
      <div className="change-password-required-card">
        <div className="change-password-required-header">
          <i
            className="pi pi-exclamation-triangle"
            style={{ fontSize: '3rem', color: '#ff9800' }}
          ></i>
          <h1>נדרש שינוי סיסמא</h1>
        </div>

        <div className="change-password-required-message">
          <p>
            מטעמי אבטחה, נדרש לשנות את הסיסמא שלך על מנת להמשיך להשתמש במערכת.
          </p>
          <p>אנא בחר סיסמא חזקה ובטוחה.</p>
        </div>

        <div className="change-password-required-form">
          {isLoading ? (
            <div>טוען...</div>
          ) : (
            <ChangePasswordFlow
              userEmail={userEmail}
              userPhoneNumber={userPhoneNumber}
              onSuccess={handlePasswordChangeSuccess}
              autoStart={true}
            />
          )}
        </div>
      </div>
    </div>
  );
});
